var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            ref: "overlay",
            staticClass: "governance-overlay",
            attrs: {
              role: "alertdialog",
              "aria-modal": "true",
              "aria-labelledby": "governance-overlay-title",
              tabindex: "-1",
            },
          },
          [
            _c("div", { staticClass: "governance-overlay__backdrop" }),
            _c(
              "div",
              { staticClass: "governance-overlay__panel" },
              [
                _c("div", { staticClass: "governance-overlay__topbar" }),
                _c("div", { staticClass: "governance-overlay__icon-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "governance-overlay__shield" },
                    [
                      _c("v-icon", { attrs: { color: "error", size: "44" } }, [
                        _vm._v("mdi-shield-alert-outline"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "governance-overlay__lock-badge" },
                    [
                      _c("v-icon", { attrs: { color: "white", size: "14" } }, [
                        _vm._v("mdi-lock"),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c(
                  "h2",
                  {
                    staticClass: "governance-overlay__title",
                    attrs: { id: "governance-overlay-title" },
                  },
                  [_vm._v(" Acesso Bloqueado ")]
                ),
                _c("p", { staticClass: "governance-overlay__subtitle" }, [
                  _c("strong", [_vm._v("Atenção:")]),
                  _vm._v(
                    " seu grupo de gestão atingiu o limite de notificações para "
                  ),
                  _vm.rooms.length === 1
                    ? _c("strong", [
                        _vm._v(
                          'a sala "' +
                            _vm._s(_vm.rooms[0].name || `#${_vm.rooms[0].id}`) +
                            '"'
                        ),
                      ])
                    : _c("strong", [
                        _vm._v(
                          _vm._s(_vm.rooms.length) + " salas listadas abaixo"
                        ),
                      ]),
                  _vm._v(
                    ". Resolva a pendência para liberar os demais módulos. "
                  ),
                ]),
                _c(
                  "p",
                  {
                    staticClass:
                      "governance-overlay__subtitle governance-overlay__headline",
                  },
                  [_vm._v(" " + _vm._s(_vm.headlineText) + ". ")]
                ),
                _c(
                  "ul",
                  { staticClass: "governance-overlay__rooms" },
                  _vm._l(_vm.rooms, function (room) {
                    return _c(
                      "li",
                      { key: room.id, staticClass: "governance-overlay__room" },
                      [
                        _c(
                          "div",
                          { staticClass: "governance-overlay__room-icon" },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: "#b91c1c" } },
                              [_vm._v("mdi-lock-outline")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "governance-overlay__room-info" },
                          [
                            _c(
                              "div",
                              { staticClass: "governance-overlay__room-name" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(room.name || `Sala #${room.id}`) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "governance-overlay__room-meta" },
                              [
                                room.days_in_red != null
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(room.days_in_red) +
                                          " dia(s) sem ação "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          { staticClass: "governance-overlay__room-chip" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(room.students || 0) +
                                "/" +
                                _vm._s(room.capacity || 0) +
                                " "
                            ),
                            room.percent
                              ? _c("strong", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(Math.round(room.percent)) +
                                      "%)"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "governance-overlay__hint" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "#475569" },
                      },
                      [_vm._v("mdi-refresh")]
                    ),
                    _vm._v(
                      " O acesso será restaurado automaticamente assim que todas as salas acima deixarem o estado Vermelho — seja por realocação de turma ou ajuste de capacidade. "
                    ),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "governance-overlay__cta",
                    attrs: {
                      color: "error",
                      block: "",
                      large: "",
                      depressed: "",
                    },
                    on: { click: _vm.goToVacancyControl },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-arrow-right-bold"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.ctaLabel) + " "),
                  ],
                  1
                ),
                _vm.isOnVacancyControl
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "governance-overlay__dismiss",
                        attrs: { text: "", small: "" },
                        on: { click: _vm.dismiss },
                      },
                      [_vm._v(" Continuar nesta tela ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }